import {Dialog, Transition} from "@headlessui/react";
import {Fragment} from "preact";
import {ScopedLoader} from "../../../index";
import {useWarehouseModal} from "./useWarehouseModal";
import s from "./warehouseModal.module.css";
import Content from "./Content";
import {useAppContext} from "../../../../contexts";

const WarehouseModal = () => {
    // Component logic data
    const componentProps = useWarehouseModal();

    // Destructured component logic data
    const {
        isLoading,
        sidebarCartData,
        handleCart,
        handleIsOpen,
        handleIsLoading
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Loader variable
    const loader = isLoading && (
        <div className={"py-14"}>
            <ScopedLoader />
        </div>
    );

    return (
        <Fragment>
            <Transition.Root show={sidebarCartData["isSameWarehouseModalOpen"]} as={Fragment}>
                <Dialog as="div" className="relative z-[25]" onClose={handleIsOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                    </Transition.Child>
                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full px-4 md:px-0 items-center justify-center text-center sm:items-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-700"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-300"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className={`${s.contentRoot} ${highContrast ? "highGrayColor" : "bg-white"}`}>
                                    {loader}

                                    {/* Main content */}
                                    <Content
                                        sidebarCartData={sidebarCartData}
                                        handleCart={handleCart}
                                        handleIsOpen={handleIsOpen}
                                    />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </Fragment>
    )
}

export default WarehouseModal;
